import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignJustifySizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15 3H1v2h14V3zM1 7h14v2H1V7zm0 4h14v2H1v-2z" />
  </svg>
);
export default IconAlignJustifySizeS;
